<template>
  <div>
    <v-card
      class="my-2"
      flat
      height="456px"
    >
      <v-card-text>
        <v-skeleton-loader type="card" />
      </v-card-text>
    </v-card>

    <v-card
      class="my-2"
      flat
      height="102px"
    >
      <v-card-text>
        <v-skeleton-loader type="heading" />
      </v-card-text>
    </v-card>

    <v-card
      class="my-2"
      flat
      height="326px"
    >
      <v-card-text>
        <v-skeleton-loader type="card" />
        <v-row>
          <v-spacer />
          <v-skeleton-loader
            type="image"
            width="300px"
            height="40px"
          />
          <v-spacer />
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'FlightOrderSummaryLoader'
}
</script>

<style scoped>

</style>
